import { ToolCard } from '@/components/ToolCard';
import { Empty, EmptyHeader, EmptyMedia, EmptyTitle, EmptyDescription } from '@/components/ui/empty';
import { type Tool } from '@/data/tools';
import { Search, PackageOpen } from 'lucide-react';

type ToolGridProps = {
  tools: Tool[];
  onToolClick: (tool: Tool) => void;
  isFavorite?: (toolId: string) => boolean;
  onToggleFavorite?: (toolId: string) => void;
};

export function ToolGrid({ tools, onToolClick, isFavorite, onToggleFavorite }: ToolGridProps) {
  if (tools.length === 0) {
    return (
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant='icon'>
            <PackageOpen />
          </EmptyMedia>
          <EmptyTitle>No tools found</EmptyTitle>
          <EmptyDescription>Try adjusting your filters or enable external tools in the sidebar</EmptyDescription>
        </EmptyHeader>
      </Empty>
    );
  }

  return (
    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4'>
      {tools.map((tool) => (
        <ToolCard
          key={tool.id}
          tool={tool}
          onClick={() => onToolClick(tool)}
          isFavorite={isFavorite?.(tool.id)}
          onToggleFavorite={onToggleFavorite}
        />
      ))}
    </div>
  );
}
